import firestoreDB from '@/libs/firebase.init';

export default {
    namespaced: true,
    state: {
        callInfo: null,
        // localVideoTrack: null,
        audioEnabled: true,
        videoEnabled: true,
    },
    getters: {
        getCallInfo: (state) => state.callInfo,
        isCallIncoming: (state) => state.callInfo !== null,
    },
    mutations: {
        storedCallInfo(state, doc) {
            state.callInfo = doc;
            if (state.callInfo === null) {
                localStorage.setItem('endcall', "true");
            }
        },

    },
    actions: {
        setCallInfo({commit}, call_info) {
            commit('storedCallInfo', call_info);
        },
        initializeFirebaseListener({commit}, user_code) {
            firestoreDB.collection('patientcall')
                .doc(user_code)
                .onSnapshot(doc => {
                    if (doc.exists) {
                        commit('storedCallInfo', doc.data())
                    }
                })
        },


    },
};
